// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7d31db60","92":"07bc4c4b","110":"2a88c7fa","124":"dad8f755","460":"fec50a98","493":"aad8decd","525":"cf5d324c","586":"75019819","605":"dc3f79f1","664":"8313e107","720":"cf4ae010","981":"c263ce12"}[chunkId] + ".chunk.js";
};